// import { useState, useEffect } from 'react';
import DeterministicRandom from 'seedrandom';

const usePatternGenerator = (id, object) => {
    const properties = Object.keys(object);
    const objectSize = properties.length;
    const probability = DeterministicRandom(id)();

    const arrayResult = properties.map((property, index) => {
        const lowerLimit = (1 / objectSize) * index;
        const upperLimit = (1 / objectSize) * (index + 1);

        if (lowerLimit < probability && probability < upperLimit) {
            return property;
        }
        return null;
    });
    const finalResult = arrayResult.find(element => element !== null);

    return finalResult;
};

export default usePatternGenerator;
